/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for EnseignantResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, EnseignantDTO } from "../models";

@Injectable({ providedIn: "root" })
export class EnseignantResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    findAllEnseignant14(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<EnseignantDTO>>;
    findAllEnseignant14(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<EnseignantDTO>>>;
    findAllEnseignant14(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<EnseignantDTO>>>;
    findAllEnseignant14(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-enseignants`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignant15(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<EnseignantDTO>>;
    findAllEnseignant15(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<EnseignantDTO>>>;
    findAllEnseignant15(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<EnseignantDTO>>>;
    findAllEnseignant15(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-enseignants`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignant16(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<EnseignantDTO>>;
    findAllEnseignant16(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<EnseignantDTO>>>;
    findAllEnseignant16(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<EnseignantDTO>>>;
    findAllEnseignant16(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-enseignants`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignant18(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<EnseignantDTO>>;
    findAllEnseignant18(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<EnseignantDTO>>>;
    findAllEnseignant18(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<EnseignantDTO>>>;
    findAllEnseignant18(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-enseignants`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignant17(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<EnseignantDTO>>;
    findAllEnseignant17(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<EnseignantDTO>>>;
    findAllEnseignant17(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<EnseignantDTO>>>;
    findAllEnseignant17(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-enseignants`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignant20(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<EnseignantDTO>>;
    findAllEnseignant20(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<EnseignantDTO>>>;
    findAllEnseignant20(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<EnseignantDTO>>>;
    findAllEnseignant20(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-enseignants`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignant19(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<EnseignantDTO>>;
    findAllEnseignant19(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<EnseignantDTO>>>;
    findAllEnseignant19(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<EnseignantDTO>>>;
    findAllEnseignant19(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-enseignants`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignantJsonEnseignantSelect(archive?: boolean, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<EnseignantDTO>>;
    findAllEnseignantJsonEnseignantSelect(archive?: boolean, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<EnseignantDTO>>>;
    findAllEnseignantJsonEnseignantSelect(archive?: boolean, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<EnseignantDTO>>>;
    findAllEnseignantJsonEnseignantSelect(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-enseignants-select`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignantJsonEnseignantSelect1(archive?: boolean, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<EnseignantDTO>>;
    findAllEnseignantJsonEnseignantSelect1(archive?: boolean, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<EnseignantDTO>>>;
    findAllEnseignantJsonEnseignantSelect1(archive?: boolean, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<EnseignantDTO>>>;
    findAllEnseignantJsonEnseignantSelect1(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-enseignants-select`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignantJsonEnseignantSelect2(archive?: boolean, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<EnseignantDTO>>;
    findAllEnseignantJsonEnseignantSelect2(archive?: boolean, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<EnseignantDTO>>>;
    findAllEnseignantJsonEnseignantSelect2(archive?: boolean, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<EnseignantDTO>>>;
    findAllEnseignantJsonEnseignantSelect2(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-enseignants-select`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignantJsonEnseignantSelect4(archive?: boolean, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<EnseignantDTO>>;
    findAllEnseignantJsonEnseignantSelect4(archive?: boolean, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<EnseignantDTO>>>;
    findAllEnseignantJsonEnseignantSelect4(archive?: boolean, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<EnseignantDTO>>>;
    findAllEnseignantJsonEnseignantSelect4(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-enseignants-select`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignantJsonEnseignantSelect3(archive?: boolean, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<EnseignantDTO>>;
    findAllEnseignantJsonEnseignantSelect3(archive?: boolean, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<EnseignantDTO>>>;
    findAllEnseignantJsonEnseignantSelect3(archive?: boolean, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<EnseignantDTO>>>;
    findAllEnseignantJsonEnseignantSelect3(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-enseignants-select`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignantJsonEnseignantSelect6(archive?: boolean, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<EnseignantDTO>>;
    findAllEnseignantJsonEnseignantSelect6(archive?: boolean, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<EnseignantDTO>>>;
    findAllEnseignantJsonEnseignantSelect6(archive?: boolean, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<EnseignantDTO>>>;
    findAllEnseignantJsonEnseignantSelect6(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-enseignants-select`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignantJsonEnseignantSelect5(archive?: boolean, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<EnseignantDTO>>;
    findAllEnseignantJsonEnseignantSelect5(archive?: boolean, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<EnseignantDTO>>>;
    findAllEnseignantJsonEnseignantSelect5(archive?: boolean, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<EnseignantDTO>>>;
    findAllEnseignantJsonEnseignantSelect5(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-enseignants-select`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEnseignant(naturePeice?: number, numeroPiece?: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<EnseignantDTO>;
    findEnseignant(naturePeice?: number, numeroPiece?: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<EnseignantDTO>>;
    findEnseignant(naturePeice?: number, numeroPiece?: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<EnseignantDTO>>;
    findEnseignant(naturePeice?: number, numeroPiece?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/existe-enseignant`;

        let params = new HttpParams();
        if (naturePeice != null) {
            params = HttpParamsBuilder.addToHttpParams(params, naturePeice, 'naturePeice');
        }
        if (numeroPiece != null) {
            params = HttpParamsBuilder.addToHttpParams(params, numeroPiece, 'numeroPiece');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEnseignant1(naturePeice?: number, numeroPiece?: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<EnseignantDTO>;
    findEnseignant1(naturePeice?: number, numeroPiece?: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<EnseignantDTO>>;
    findEnseignant1(naturePeice?: number, numeroPiece?: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<EnseignantDTO>>;
    findEnseignant1(naturePeice?: number, numeroPiece?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/existe-enseignant`;

        let params = new HttpParams();
        if (naturePeice != null) {
            params = HttpParamsBuilder.addToHttpParams(params, naturePeice, 'naturePeice');
        }
        if (numeroPiece != null) {
            params = HttpParamsBuilder.addToHttpParams(params, numeroPiece, 'numeroPiece');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEnseignant2(naturePeice?: number, numeroPiece?: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<EnseignantDTO>;
    findEnseignant2(naturePeice?: number, numeroPiece?: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<EnseignantDTO>>;
    findEnseignant2(naturePeice?: number, numeroPiece?: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<EnseignantDTO>>;
    findEnseignant2(naturePeice?: number, numeroPiece?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/existe-enseignant`;

        let params = new HttpParams();
        if (naturePeice != null) {
            params = HttpParamsBuilder.addToHttpParams(params, naturePeice, 'naturePeice');
        }
        if (numeroPiece != null) {
            params = HttpParamsBuilder.addToHttpParams(params, numeroPiece, 'numeroPiece');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEnseignant4(naturePeice?: number, numeroPiece?: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<EnseignantDTO>;
    findEnseignant4(naturePeice?: number, numeroPiece?: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<EnseignantDTO>>;
    findEnseignant4(naturePeice?: number, numeroPiece?: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<EnseignantDTO>>;
    findEnseignant4(naturePeice?: number, numeroPiece?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/existe-enseignant`;

        let params = new HttpParams();
        if (naturePeice != null) {
            params = HttpParamsBuilder.addToHttpParams(params, naturePeice, 'naturePeice');
        }
        if (numeroPiece != null) {
            params = HttpParamsBuilder.addToHttpParams(params, numeroPiece, 'numeroPiece');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEnseignant3(naturePeice?: number, numeroPiece?: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<EnseignantDTO>;
    findEnseignant3(naturePeice?: number, numeroPiece?: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<EnseignantDTO>>;
    findEnseignant3(naturePeice?: number, numeroPiece?: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<EnseignantDTO>>;
    findEnseignant3(naturePeice?: number, numeroPiece?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/existe-enseignant`;

        let params = new HttpParams();
        if (naturePeice != null) {
            params = HttpParamsBuilder.addToHttpParams(params, naturePeice, 'naturePeice');
        }
        if (numeroPiece != null) {
            params = HttpParamsBuilder.addToHttpParams(params, numeroPiece, 'numeroPiece');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEnseignant6(naturePeice?: number, numeroPiece?: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<EnseignantDTO>;
    findEnseignant6(naturePeice?: number, numeroPiece?: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<EnseignantDTO>>;
    findEnseignant6(naturePeice?: number, numeroPiece?: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<EnseignantDTO>>;
    findEnseignant6(naturePeice?: number, numeroPiece?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/existe-enseignant`;

        let params = new HttpParams();
        if (naturePeice != null) {
            params = HttpParamsBuilder.addToHttpParams(params, naturePeice, 'naturePeice');
        }
        if (numeroPiece != null) {
            params = HttpParamsBuilder.addToHttpParams(params, numeroPiece, 'numeroPiece');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findEnseignant5(naturePeice?: number, numeroPiece?: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<EnseignantDTO>;
    findEnseignant5(naturePeice?: number, numeroPiece?: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<EnseignantDTO>>;
    findEnseignant5(naturePeice?: number, numeroPiece?: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<EnseignantDTO>>;
    findEnseignant5(naturePeice?: number, numeroPiece?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/existe-enseignant`;

        let params = new HttpParams();
        if (naturePeice != null) {
            params = HttpParamsBuilder.addToHttpParams(params, naturePeice, 'naturePeice');
        }
        if (numeroPiece != null) {
            params = HttpParamsBuilder.addToHttpParams(params, numeroPiece, 'numeroPiece');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    addorUpdateEnseignant(enseignantDTO: EnseignantDTO, observe?: 'body', options?: RequestOptions<'blob'>): Observable<EnseignantDTO>;
    addorUpdateEnseignant(enseignantDTO: EnseignantDTO, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<EnseignantDTO>>;
    addorUpdateEnseignant(enseignantDTO: EnseignantDTO, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<EnseignantDTO>>;
    addorUpdateEnseignant(enseignantDTO: EnseignantDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/addOrUpdateEnseignant`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    addorUpdateEnseignant1(enseignantDTO: EnseignantDTO, observe?: 'body', options?: RequestOptions<'blob'>): Observable<EnseignantDTO>;
    addorUpdateEnseignant1(enseignantDTO: EnseignantDTO, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<EnseignantDTO>>;
    addorUpdateEnseignant1(enseignantDTO: EnseignantDTO, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<EnseignantDTO>>;
    addorUpdateEnseignant1(enseignantDTO: EnseignantDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/addOrUpdateEnseignant`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: enseignantDTO,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    addorUpdateEnseignant2(enseignantDTO: EnseignantDTO, observe?: 'body', options?: RequestOptions<'blob'>): Observable<EnseignantDTO>;
    addorUpdateEnseignant2(enseignantDTO: EnseignantDTO, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<EnseignantDTO>>;
    addorUpdateEnseignant2(enseignantDTO: EnseignantDTO, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<EnseignantDTO>>;
    addorUpdateEnseignant2(enseignantDTO: EnseignantDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/addOrUpdateEnseignant`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: enseignantDTO,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    addorUpdateEnseignant4(enseignantDTO: EnseignantDTO, observe?: 'body', options?: RequestOptions<'blob'>): Observable<EnseignantDTO>;
    addorUpdateEnseignant4(enseignantDTO: EnseignantDTO, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<EnseignantDTO>>;
    addorUpdateEnseignant4(enseignantDTO: EnseignantDTO, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<EnseignantDTO>>;
    addorUpdateEnseignant4(enseignantDTO: EnseignantDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/addOrUpdateEnseignant`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: enseignantDTO,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    addorUpdateEnseignant3(enseignantDTO: EnseignantDTO, observe?: 'body', options?: RequestOptions<'blob'>): Observable<EnseignantDTO>;
    addorUpdateEnseignant3(enseignantDTO: EnseignantDTO, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<EnseignantDTO>>;
    addorUpdateEnseignant3(enseignantDTO: EnseignantDTO, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<EnseignantDTO>>;
    addorUpdateEnseignant3(enseignantDTO: EnseignantDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/addOrUpdateEnseignant`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    addorUpdateEnseignant6(enseignantDTO: EnseignantDTO, observe?: 'body', options?: RequestOptions<'blob'>): Observable<EnseignantDTO>;
    addorUpdateEnseignant6(enseignantDTO: EnseignantDTO, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<EnseignantDTO>>;
    addorUpdateEnseignant6(enseignantDTO: EnseignantDTO, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<EnseignantDTO>>;
    addorUpdateEnseignant6(enseignantDTO: EnseignantDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/addOrUpdateEnseignant`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    addorUpdateEnseignant5(enseignantDTO: EnseignantDTO, observe?: 'body', options?: RequestOptions<'blob'>): Observable<EnseignantDTO>;
    addorUpdateEnseignant5(enseignantDTO: EnseignantDTO, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<EnseignantDTO>>;
    addorUpdateEnseignant5(enseignantDTO: EnseignantDTO, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<EnseignantDTO>>;
    addorUpdateEnseignant5(enseignantDTO: EnseignantDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/addOrUpdateEnseignant`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
